"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Accordion2 = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionDetails2 = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));

var _AccordionSummary2 = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _TableExpandIcon = _interopRequireDefault(require("../TableExpandIcon"));

var _utils = require("../utils");

var _TableMobile = require("./TableMobile.styles");

var TableMobile = function TableMobile(props) {
  var columns = props.columns,
      data = props.data,
      rowKey = props.rowKey,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["columns", "data", "rowKey"]);
  var visibleColumns = columns.filter(function (column) {
    return column.mobileProps && column.mobileProps.visible;
  });
  var hiddenColumns = columns.filter(function (column) {
    return visibleColumns.indexOf(column) < 0;
  });
  var expansionPanelClasses = (0, _TableMobile.useTableRowStyles)(otherProps);
  var expansionPanelSummaryClasses = (0, _TableMobile.useTableRowHeaderStyles)();
  var expansionPanelDetailsClasses = (0, _TableMobile.useTableRowBodyStyles)();
  var cellClasses = (0, _TableMobile.useTableCellStyles)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pds-table-mobile"
  }, data.map(function (rowData) {
    return /*#__PURE__*/_react.default.createElement(_Accordion2.default, {
      key: rowData[rowKey],
      className: "pds-table-mobile__row",
      classes: expansionPanelClasses,
      elevation: 0,
      square: true
    }, /*#__PURE__*/_react.default.createElement(_AccordionSummary2.default, {
      className: "pds-table-mobile__row-header",
      classes: expansionPanelSummaryClasses,
      expandIcon: /*#__PURE__*/_react.default.createElement(_TableExpandIcon.default, {
        style: {
          width: 24,
          height: 24
        }
      })
    }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
      display: "flex",
      flexDirection: "row",
      width: "100%"
    }, visibleColumns.map(function (column) {
      var content = (0, _utils.getCellContent)(column, rowData);
      var columnClasses = (0, _classnames.default)('pds-table-mobile__column', column.className);
      return /*#__PURE__*/_react.default.createElement(_Box2.default, {
        key: column.id,
        className: columnClasses,
        flexGrow: 1,
        textAlign: column.align
      }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
        className: cellClasses.label
      }, column.header), /*#__PURE__*/_react.default.createElement(_Box2.default, {
        className: cellClasses.content
      }, content));
    }))), /*#__PURE__*/_react.default.createElement(_AccordionDetails2.default, {
      className: "pds-table-mobile__row-body",
      classes: expansionPanelDetailsClasses
    }, hiddenColumns.map(function (column) {
      var columnClasses = (0, _classnames.default)('pds-table-mobile__column', column.className);
      var content = (0, _utils.getCellContent)(column, rowData);
      return /*#__PURE__*/_react.default.createElement(_Box2.default, {
        key: column.id,
        className: columnClasses,
        display: "flex",
        alignItems: "flex-end",
        flexDirection: "row",
        height: "32px"
      }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
        className: cellClasses.label,
        flexGrow: 1
      }, column.header), /*#__PURE__*/_react.default.createElement(_Box2.default, {
        className: cellClasses.content,
        flexGrow: 1,
        textAlign: "right"
      }, content));
    })));
  }));
};

TableMobile.propTypes = {
  /** Array of column definitions used to draw the table. */
  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    align: (0, _propTypes.oneOf)(['center', 'left', 'right', 'justify']),
    className: _propTypes.string,
    field: _propTypes.string,
    header: _propTypes.node,
    id: _propTypes.string.isRequired,
    mobileProps: (0, _propTypes.shape)({
      visible: _propTypes.bool
    }),
    render: _propTypes.func,
    sortable: _propTypes.bool
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: _propTypes.array.isRequired,

  /** If the table should have a border between each row. */
  dividers: _propTypes.bool,

  /** The field that should be used to generate the React key of each row. */
  rowKey: _propTypes.string.isRequired,

  /** If the table should have zebra stripes. */
  zebra: _propTypes.bool
};
var _default = TableMobile;
exports.default = _default;
